<template>
  <div id="custom-header">
    <div class="system-name">订单管理系统</div>
    <div class="collapse-btn" @click="packUpTheMene" @dblclick="packUpTheMene">
      <i class="el-icon-s-fold"></i>
      <!-- <i v-if="!menuCollapse" class="el-icon-s-fold"></i> -->
      <!-- <i v-else class="el-icon-s-unfold"></i> -->
    </div>
    <!-- 下拉筛选 -->
    <div v-if="showChoose">
      <el-select v-model="scenicNum" filterable placeholder="请选择景区">
        <el-option
          v-for="item in scenics"
          :key="item.scenic_num"
          :label="item.scenic_name"
          :value="item.scenic_num"
        >
        </el-option>
      </el-select>
      <!-- <el-button type="primary" style="margin-left: 20px" @click="chooseSecnic"
        >搜索</el-button
      > -->
      <span style="display: none">{{ currentScenicInfo }}</span>
    </div>

    <div class="header-right">
      <div class="header-user-con">
        <!-- 全屏显示 -->
        <div class="btn-fullscreen" @click="handleFullScreen">
          <el-tooltip
            effect="dark"
            :content="fullscreen ? `取消全屏` : `全屏`"
            placement="bottom"
          >
            <i class="el-icon-rank"></i>
          </el-tooltip>
        </div>

        <!-- 用户头像 -->
        <div class="user-avator">
          <img src="/static/login-bg.jpg" />
        </div>
        <!-- 用户名下拉菜单 -->
        <el-dropdown class="user-name" trigger="click" @command="handleCommand">
          <span class="el-dropdown-link" :class="isPc ? '' : 'font-size-phone'">
            {{ user }}
            <i class="el-icon-caret-bottom"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <!-- <el-dropdown-item divided command="resetPassword"
              >修改密码</el-dropdown-item
            >-->
            <el-dropdown-item
              v-if="user == 'kechunlin'"
              divided
              command="coupon"
              :class="isPc ? '' : 'font-size-phone'"
              >生成兑换码</el-dropdown-item
            >
            <el-dropdown-item
              divided
              command="loginout"
              :class="isPc ? '' : 'font-size-phone'"
              >退出登录</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>

    <!-- dialog -->
    <!-- loginout  -->
    <el-dialog title="提示" :visible.sync="loginoutStatus" width="30%" center>
      <span>确定要退出系统吗？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="loginoutStatus = false">取 消</el-button>
        <el-button type="primary" @click="loginOut">确 定</el-button>
      </span>
    </el-dialog>

    <!-- coupon  -->
    <el-dialog
      title="生成券码"
      :visible.sync="couponStatus"
      width="456px"
      center
      v-loading="loading"
      element-loading-text="生成券码中请稍后"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.2)"
      v-if="couponStatus"
    >
      <el-form
        :model="ruleForm"
        status-icon
        :rules="rules"
        ref="couponForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="景区id" prop="scenic_num">
          <el-input
            style="width: 240px"
            v-model="ruleForm.scenic_num"
            autocomplete="off"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="pass">
          <el-input
            style="width: 240px"
            v-model="ruleForm.pass"
            autocomplete="off"
            clearable
          ></el-input>
        </el-form-item>
      </el-form>
      <el-tag
        :key="tag"
        v-for="tag in couponCodes"
        :disable-transitions="false"
        style="margin: 3px"
      >
        {{ tag }}
      </el-tag>
      <!-- <span>确定要退出系统吗？</span> -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="couponStatus = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">生成券码</el-button>
        <el-button type="primary" @click="exportCoupon">导出券码</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import excel from "../../export/libs/excel";
export default {
  name: "custom-header",
  computed: {
    ...mapState(["menuCollapse"]),
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.ruleForm.pass == "yz2023") {
          callback();
        } else {
          callback(new Error("请输入正确密码"));
        }
      }
    };
    return {
      fullscreen: false,
      loginoutStatus: false,
      user: "",
      scenicNum: "",
      isPc: true,
      couponStatus: false,
      ruleForm: {
        scenic_num: "",
        pass: "",
      },
      rules: {
        pass: [{ validator: validatePass, trigger: "blur" }],
      },
      couponCodes: [],
      loading: false,
    };
  },
  watch: {
    scenicNum() {
      this.chooseSecnic();
    },
    couponStatus(newval, oldval) {
      if (newval === false) {
        this.ruleForm.pass = "";
        this.ruleForm.scenic_num = "";
        this.couponCodes = [];
      }
    },
  },
  computed: {
    showChoose() {
      // 以下这些页面不显示景点选择
      const path = this.$route.path,
        hidenPaths = [
          "/chooseScenic",
          "/createUser",
          "/manageList",
          "/createAdmin",
          "/scenicList",
          "/faceTransplant",
          // "/financialStatistics",
          "/newFinancialStatistics",
          // 这里记得要改,
        ];
      if (hidenPaths.includes(path)) {
        return false;
      } else {
        return true;
      }
    },
    scenics() {
      return JSON.parse(localStorage.getItem("scenics"));
    },

    currentScenicInfo() {
      const currentScenicInfo = JSON.parse(
        localStorage.getItem("currentScenicInfo")
      );

      if (currentScenicInfo) {
        this.scenicNum = currentScenicInfo.scenic_num;
        return currentScenicInfo;
      } else {
        return "";
      }
    },
  },
  created() {
    this.user = localStorage.getItem("user");
    this.isPc = JSON.parse(sessionStorage.getItem("isPc"));
  },
  methods: {
    ...mapMutations(["amendState"]),

    // 折叠左边栏菜单
    packUpTheMene() {
      // this.amendState({ menuCollapse: !this.menuCollapse });
    },

    // 用户名下拉菜单选择事件
    handleCommand(command) {
      if (command === "loginout") {
        this.loginoutStatus = true;
      } else if (command === "resetPassword") {
      } else if (command === "coupon") {
        this.couponStatus = true;
      }
    },

    loginOut() {
      const outPath = this.user === "admin" ? "/manageLogin" : "/login";
      localStorage.clear();
      this.$router.replace(outPath);
    },

    submitForm() {
      this.$refs["couponForm"].validate((valid) => {
        if (valid) {
          // 获取订单列表
          let { ruleForm } = this,
            params = {
              scenic_num: ruleForm.scenic_num,
            };
          this.generateCoupon(params);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    generateCoupon(params) {
      let { couponCodes } = this;
      if (couponCodes.length > 99) {
        this.loading = false;
        return;
      } else {
        this.loading = true;
        this.$Http.getCouponCode(params).then((res) => {
          if (res) {
            this.couponCodes.push(res.data.voucher_code);
            this.$nextTick(() => {
              this.generateCoupon(params);
            });
          }
        });
      }
    },

    // 导出券码
    exportCoupon() {
      const { scenic_num, pass } = this.ruleForm;
      if (!scenic_num || pass != "yz2023" || this.loading) {
        return;
      }
      const couponCodes = this.couponCodes;
      const permissions = JSON.parse(localStorage.getItem("permissions"));
      const filename = permissions[scenic_num].scenic_name;
      const dataList = couponCodes.map((item, index) => {
        return {
          index: index,
          couponCode: item,
        };
      });
      const params = {
        title: ["", "兑换码"],
        key: ["index", "couponCode"],
        data: dataList, // 数据源
        autoWidth: true, //autoWidth等于true，那么列的宽度会适应那一列最长的值
        filename: filename + "券码",
      };
      excel.exportArrayToExcel(params);
    },

    chooseSecnic() {
      if (this.currentScenicInfo.scenic_num !== this.scenicNum) {
        const index = this.scenics.findIndex(
            (item) => item.scenic_num == this.scenicNum
          ),
          scenic = this.scenics[index];

        const permissions = JSON.parse(localStorage.getItem("permissions")),
          menus = permissions[scenic.scenic_num];
        localStorage.setItem("currentScenicInfo", JSON.stringify(scenic));
        localStorage.setItem("menus", JSON.stringify(menus.menus));
        location.reload();
      } else {
        // console.log("重复选择景点");
      }
    },

    // 全屏事件
    handleFullScreen() {
      let element = document.documentElement;
      if (this.fullscreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      } else {
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.msRequestFullscreen) {
          // IE11
          element.msRequestFullscreen();
        }
      }
      this.fullscreen = !this.fullscreen;
    },
  },
};
</script>
<style lang="scss" scoped>
#custom-header {
  display: flex;
  align-items: center;
  height: 70px;
  background-color: #fff;
}

.collapse-btn {
  font-size: 30px;
  padding: 0 21px;
  // cursor: pointer;
}

.system-name {
  box-sizing: border-box;
  padding-left: 13px;
  width: 200px;
  height: 70px;
  line-height: 70px;
  font-size: 22px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  text-align: left;
  color: #ffffff;
  background-color: #242f42;
}

.header-right {
  position: absolute;
  right: 50px;
}

.header-user-con {
  display: flex;
  height: 70px;
  align-items: center;
}

.btn-fullscreen {
  transform: rotate(45deg);
  margin-right: 5px;
  font-size: 24px;
}

.btn-bell,
.btn-fullscreen {
  position: relative;
  width: 30px;
  height: 30px;
  text-align: center;
  border-radius: 15px;
  cursor: pointer;
}

.btn-bell-badge {
  position: absolute;
  right: 0;
  top: -2px;
  width: 8px;
  height: 8px;
  border-radius: 4px;
  background: #f56c6c;
  color: #fff;
}

.btn-bell .el-icon-bell {
  color: #fff;
}

.user-name {
  margin-left: 10px;
}

.user-avator {
  margin-left: 20px;
}

.user-avator img {
  display: block;
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

.el-dropdown-link {
  color: #000;
  cursor: pointer;
}

.el-dropdown-menu__item {
  text-align: center;
}

.font-size-phone {
  font-size: 36px;
}
</style>


// WEBPACK FOOTER //
// src/components/common/header.vue